import { render, staticRenderFns } from "./aiQuotePriceSet.vue?vue&type=template&id=666a9c76&scoped=true&"
import script from "./aiQuotePriceSet.vue?vue&type=script&lang=js&"
export * from "./aiQuotePriceSet.vue?vue&type=script&lang=js&"
import style0 from "./aiQuotePriceSet.vue?vue&type=style&index=0&id=666a9c76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666a9c76",
  null
  
)

export default component.exports